<template>
    <el-card shadow="never">
      <div class="header">
        <el-breadcrumb class="breadcrumb" separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">工作台</el-breadcrumb-item>
            <el-breadcrumb-item>分类列表</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button type="primary" class="editbtn" @click="showCatesBox" style="margin-right:10px">添加分类</el-button>
      </div>
    </el-card>
    <el-card shadow="never" style="margin-top:20px">
      <el-tree
          ref="treeRef"
          class="filter-tree"
          :expand-on-click-node="false"
          :data="baseData.datalist"
          :props="defaultProps"
          default-expand-all
      >
        <template #default="{ data }">
          <span class="custom-tree-node">
            <span>{{ data.title }}</span>
            <span>
              <el-button type="success" size="small" @click="showEidtCatesBox(data)" style="margin-right:10px">编辑</el-button>
              <el-button type="danger" size="small" @click="del_cate(data.id)" style="margin-right:10px">删除</el-button>
            </span>
          </span>
        </template>
      </el-tree>
    </el-card>

    <el-dialog v-model="baseData.catesbox" :title="baseData.title">
      <el-form :model="formData" label-width="120">
        <el-form-item label="分类名称">
          <el-input v-model="formData.catagory_name" autocomplete="off" />
        </el-form-item>
        <el-form-item label="上级分类">
          <!-- <el-select v-model="formData.parentid">
            <el-option label="" value="" />
            <el-option v-for="(item, index) in baseData.datalist" :key="index" :label="item.Title" :value="item.ID" />
          </el-select> -->
          <el-cascader
            v-model="formData.parentid"
            :options="baseData.datalist"
            :props="propss"
            :show-all-levels="false"
            filterable
            clearable
            @change="handleChange"
          />
        </el-form-item>
        <el-form-item label="图标">
          <el-row class="martop">
            <el-upload
              class="avatar-uploader"
              action=""
              :http-request="uploadImg"
              :show-file-list="false"
            >
              <img v-if="formData.img" :src="formData.img" class="avatar" />
              <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
            </el-upload>
          </el-row>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="baseData.catesbox = false">取消</el-button>
          <el-button type="primary" @click="save">提交</el-button>
        </span>
      </template>
    </el-dialog>
  </template>
  <script lang="ts" setup>
  import { reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  import {useRouter} from 'vue-router'

  const router = useRouter()
  const propss = {
    expandTrigger: 'hover' as const,
    value:'ID',
    label:'Title',
    children:'Children',
  }
  const searchForm = reactive({
    words:"",
    limit:1000,
    page:1,
  })
  const baseData:any = reactive({
    loading:false,
    userbox:false,
    datalist:[],
    catesbox:false,
    title:'新建分类',
  })
  const formData = reactive({
    catagory_name:'',
    parentid:'',
    catagoryid:'',
    img:'',
    sort:'',
  })
  const showCatesBox = () => {
    baseData.catesbox = true
    baseData.title = '新建分类'
    formData.catagory_name = ''
    formData.parentid = ''
    formData.catagoryid = ''
    formData.img = ''
    formData.sort = ''
  }
  const showEidtCatesBox = (data:any) => {
    baseData.catesbox = true
    baseData.title = '编辑分类'
    formData.catagory_name = data.title
    formData.parentid = data.parentid ? data.parentid : ''
    formData.catagoryid = data.id
    formData.img = data.img
    formData.sort = data.sort
  }
  const handleChange = (value:any) => {
    formData.parentid = value[value.length-1]
  }
  const uploadImg = (params:any) => {
    const loading = ElLoading.service({lock: true})
    const file = params.file,formData1 = new FormData();
    formData1.append("file", file)
    api.commonApi.uploadImg(formData1).then((res:any)=>{
      loading.close()
        if(res.code == 200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          formData.img = res.data.img
        }else{
          ElMessage.error(res.message)
        }
    })
  }
  const save = () => {
    baseData.loading = true
    if(formData.catagoryid){
      api.companyApi.edit_cate(formData).then((res:any)=>{
        baseData.loading = false
        if(res.code==200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          baseData.catesbox = false
          getList()
        }else{
          ElMessage.error(res.message)
        }
      })
    }else{
      api.companyApi.add_cate(formData).then((res:any)=>{
        baseData.loading = false
        if(res.code==200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          baseData.catesbox = false
          getList()
        }else{
          ElMessage.error(res.message)
        }
      })
    }
  }
  const del_cate = (id:number) => {
    api.companyApi.del_cate({catagoryid:id}).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const getList = () => {
    baseData.loading = true
    api.companyApi.get_cates_list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        baseData.datalist = res.data.list
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const changeStatus = (catagoryid:string) =>{
    api.companyApi.changeStatus({catagoryid:catagoryid}).then((res:any)=>{
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
      }else{
        ElMessage.error(res.message)
      }
      getList()
    })
  }
  const defaultProps = {
    children: 'children',
    label: 'title',
  }
  onMounted(() => {
    getList()
  })
  </script>
  <style>
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
  .el-tree-node__content{
    height: 40px;
  }
  </style>